<template>
  <div>
    
    <Row style="width: 100%;margin-top:110px">
      <Col span="24" class="backImg">
            <img :src="img" width="100%" style="vertical-align: bottom;">
      </Col>
    </Row>
   
    <Row style="width: 100%;">
      <Col span="6" >
          <h4 class="imgCss">热文排行榜</h4>
          
            <Row v-for="(item,i) in hotNews" :key="i" style="color: #616060;padding: 30px 0;overflow: hidden;height: auto;">
                  <Col span="8" style="color: #616060;text-align:left;left:110px;font-size: 15px;">
                    <router-link  style="color: #616060;"
                                  :to="{path:'/newsDataDetails',
                                      query:{info:item}}">
                      {{ item.title }}</router-link>
                  </Col>
                  <li class="iconfont icon-jiantou">&nbsp;&nbsp;&nbsp;&nbsp;</li>
              </Row>
              
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
        
         
      </Col>
      
      </br>  <Col span="18" style="">
        <Tabs value="name1" style="margin:0;height:680px;font-size: 16px;" type="line" @on-click="tabCli">
        <TabPane label="车界热文" name="name1">
             <Row v-for="(item,i) in carPage.list" :key="i" style="color: #616060;border-bottom: #d1d1d1 solid 1px;padding: 10px 0;overflow: hidden;height: auto;width: 1350px;
    margin-left: 20px;">
                  <Col span="8" style="color: #616060;text-align:left;font-size: 15px;">
                      <router-link  style="color: #616060;"
                                  :to="{path:'/newsDataDetails',
                                      query:{info:item}}">
                      {{ item.title }}</router-link>
                  </Col>
                  <Col span="16" style="text-align: right;right:20px;"><li class="iconfont icon-ai-eye">&nbsp;&nbsp;{{ item.views }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.releaseTime }}</li></Col>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Row> 

              
        </TabPane>
        <TabPane label="天然气资讯" name="name2" >
               <Row v-for="(item,i) in gasPage.list" :key="i" style="color: rgb(97, 96, 96);border-bottom: #d1d1d1 solid 1px;padding: 10px 0;overflow: hidden;height: auto;width: 1350px;
    margin-left: 20px;">
                  <Col span="8" style="color: #616060;text-align:left;font-size: 15px;">
                      <router-link  style="color: #616060;"
                                  :to="{path:'/newsDataDetails',
                                      query:{info:item}}">
                      {{ item.title }}</router-link>
                  </Col>
                  <Col span="16" style="text-align: right;right:20px;"><li class="iconfont icon-ai-eye">&nbsp;&nbsp;{{ item.views }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.releaseTime }}</li></Col>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Row>  
          </TabPane>
        <TabPane label="泽达报道" name="name3" >
            <Row v-for="(item,i) in zedataPage.list" :key="i" style="color: rgb(97, 96, 96);border-bottom: #d1d1d1 solid 1px;padding: 10px 0;overflow: hidden;height: auto;width: 1350px;
    margin-left: 20px;">
                  <Col span="8" style="text-align:left;font-size: 15px;">
                      <router-link  style="color: #616060;"
                                  :to="{path:'/newsDataDetails',
                                      query:{info:item}}">
                      {{ item.title }}</router-link>
                      
                  </Col>
                  <Col span="16" style="text-align: right;right:20px;"><li class="iconfont icon-ai-eye">&nbsp;&nbsp;{{ item.views }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.releaseTime }}</li></Col>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Row> 
               
          </TabPane>
        </Tabs>
      </Col>
    </Row>
    
       <Row :gutter="16" >
        <Col span="" style="margin-bottom: 60px;" v-if="carShow">
                    <Page :total=carPage.total :current=carPage.pageNum :page-size=carPage.pageSize  @on-change="changepageCar" show-total />
        </Col>
        <Col span="24" style="margin-bottom: 60px;" v-if="gasShow">
                    <Page :total=gasPage.total :current=gasPage.pageNum :page-size=gasPage.pageSize  @on-change="changepageGas" show-total />
        </Col>
        <Col span="24" style="margin-bottom: 60px;" v-if="zedataShow">
                    <Page :total=zedataPage.total :current=zedataPage.pageNum :page-size=zedataPage.pageSize  @on-change="changepageZeData" show-total />
        </Col>
       </Row>
    
  </div>
 
</template>
<script>

export default {
  data() {
    return {
      // arrPageSize: [5],
      columns1: [
                    {
                        title: 'Title',
                        key: 'title'
                    },
                    {
                        title: 'Views',
                        key: 'views'
                    },
                    {
                        title: 'ReleaseTime',
                        key: 'releaseTime'
                    }
                ],
               

      info:23923,
      bid:115486,
      money:16745305.75,
      noticeList:[],
      hotShow:false,
      hotNews:[],
      carShow:false,
      gasShow:false,
      zedataShow:false,
      carPage: {},
      gasPage: {},
      zedataPage: {
        pageNum: 0,
        pageSize: 0,
        size: 0,
        orderBy: null,
        startRow: 0,
        endRow: 0,
        total: 0,
        pages: "",
        list: [],
        firstPage: 0,
        prePage: 0,
        nextPage: 0,
        lastPage: 0,
        isFirstPage: true,
        isLastPage: true,
        hasPreviousPage: false,
        hasNextPage: false,
        navigatePages: 0,
        navigatepageNums: [
        ]},
      
      carouselImg:[
        {src: "../../../../static/15.jpg",href: "www.baidu.com"},
        {src: "../../../../static/220.jpg",href: "www.baidu.com"},
        {src: "../../../../static/221.jpg",href: "www.baidu.com"},
        {src: "../../../../static/22.jpg",href: "www.baidu.com"}
      ],
      img: "../../../../static/officeImg/mediaInformation/banner.webp",
      img2:"../../../../static/officeImg/index/areaGas.png",
      img3:"../../../../static/officeImg/index/areacar.png",
      img4:"../../../../static/officeImg/index/areaSound.png",
      // img3: "../../../static/1.jpg",
      // img11: "../../../static/17.jpg",
      // img12: "../../../static/18.jpg"
    };
  },
   filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm");
        }
  },
  mounted() {
    
    // //千位分割符
    //  this.money= this.toThousands(this.money,2);
  },
  created(){
    this.loadData();
  },
  methods: {
    loadData: function() {
      this.carShow = true;
      this.selectAllNews();
      this.selectHotNews();
    },

    tabCli(name){
      // alert(name);
      if(name=='name1'){
        // alert("name1");
          this.carShow = true;
          this.gasShow = false;
          this.zedataShow = false;
      }
      if(name=='name2'){
        //  alert("name2");
        this.carShow = false;
          this.gasShow = true;
          this.zedataShow = false;
      }
      if(name=='name3'){
        //  alert("name3");
        this.carShow = false;
          this.gasShow = false;
          this.zedataShow = true;
      }

      
    },

    changepageCar(index1){
      protocol.param_allNews.data={
          pageNum : index1

      }
      http.get(protocol.param_allNews).then((res)=>{
        let{msg,code,zedataPage,carPage,gasPage} = res.data;
        this.carPage = carPage;
      

      });
    },

     changepageGas(index1){
      protocol.param_allNews.data={
          pageNum : index1

      }
      http.get(protocol.param_allNews).then((res)=>{
        let{msg,code,zedataPage,carPage,gasPage} = res.data;
        this.gasPage = gasPage;
      

      });
    },

    changepageZedata(index1){
      protocol.param_allNews.data={
          pageNum : index1

      }
      http.get(protocol.param_allNews).then((res)=>{
        let{msg,code,zedataPage,carPage,gasPage} = res.data;
        this.ZedataPage = ZedataPage;
      

      });
    },

    selectHotNews(){
      http.get(protocol.param_hotNews).then(res=>{
        this.hotNews = res.data.hotNews;
      })

    },
    selectAllNews(pageNum,pageSize){
      var pageNum  = this.carPage.pageNum;
      var pageSize = this.carPage.pageSize;
      
      protocol.param_allNews.data={
          pageSize : pageSize,
          pageNum : pageNum

      }
     
      http.get(protocol.param_allNews).then((res)=>{
        let{msg,code,zedataPage,carPage,gasPage} = res.data;
        this.carPage = carPage;
        this.gasPage = gasPage;
        this.zedataPage = zedataPage;
       
        // if (code == 0) {
        //   // this.aliasData = jsonstr;
        //   this.$message("123213211313");
        // } else {
        //   this.$message({ type: "warning", message: msg });
        // }

      });
      this.$forceUpdate;

      
    },



        
      


    
  }
};  
</script>
<style  scoped>
@import '../../assets/iconfont/myiconfont.css';
li{

list-style: none;

}
.ivu-tabs-nav {
    padding-left: 0;
    margin: 0;
    float: left;
    list-style: none;
    box-sizing: border-box;
    position: relative;
    transition: transform .5s ease-in-out;
    font-size: 16px!important;
}
.backImg {
  background-color: white;
  width: 100%;
  font-size: 25px;
  text-align: center;
  line-height: 30px;
  color: red;
  margin-top: 0px;
  margin-left: 0px;
}
.imgCss{
  line-height: 50px; font-size: 20px; background: rgb(86, 69, 247) none repeat scroll 0% 0%; margin: 0px; color: white;height: 50px;
}
.ImgLocal{
  position:relative;
  left:180px;
  margin-top:40px;
}
.FontLocal{
  margin-top:60px;
}
.title {
    text-align: center;
    color: rgb(0, 0, 0);
    font-size: 23px;
    line-height: 40px;
    padding: 1% 0px;
}
.li2 {
  width: 50%;
  font-size: 15px;
  margin-top: 6px;
}
.numInfo {
  background: white;
  font-size: larger;
  font-family: 微软雅黑;
  height: 100px;
  padding: 20px;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
}
.baseCard{
  background: white;
  font-family: 微软雅黑;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
  
}
.cardTitle{
  text-align: left;
  font-weight:540 !important;
  color: orange;
}

.li3 {
  width: 43%;
  font-size: 12px;
}
.icon-shuxian{
 font-size: 20px;
}
.shuxian{
  display:inline-block;
  width:4px;
  height: 22px;
  background: orange;
}
.icon-gengduo{
  color: orange;
}
.gengduo{
  font-family: 微软雅黑;
  color: rgb(120, 122, 123);
  font-size: 15px;
}
.wailian{
  font-size: 15px;
  font-weight:540;
  color:#787a7b;
}


</style>
<style >
.ivu-tabs-nav .ivu-tabs-tab {
    display: inline-block;
    height: 100%;
    padding: 8px 170px;
    margin-right: 16px;
    box-sizing: border-box;
    cursor: pointer;
    text-decoration: none;
    position: relative;
    transition: color .3s ease-in-out;
    font-size: 16px;
    font-weight: bold!important;
}
</style>



// WEBPACK FOOTER //
// src/views/newsData/newsData.vue